import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
    CircularProgress,
    FormControl,
    FormHelperText,
    Grid,
    Input,
    MenuItem,
    Select,
    withStyles,
} from '@material-ui/core';
import styles from './styles';
import { ExpandMore } from '@material-ui/icons';
import { has } from 'ramda';

export const SIZE_COMPACT = 'compact';
export const SIZE_LARGE = 'large';
export const SIZES = [SIZE_COMPACT, SIZE_LARGE];

class AdminSelect extends Component {
    render() {
        const {
            classes,
            type,
            options,
            value,
            loading,
            error,
            renderMenuItemDecorators,
            ...props
        } = this.props;
        const selectDisplayProps =
            type === SIZE_COMPACT
                ? { className: classes.compactDisplay }
                : { className: classes.largeDisplay };
        return loading ? (
            <Grid
                container
                direction="row"
                justify="center"
                alignItems="center"
                className={classes[`${type}Root`]}
            >
                <Grid item>
                    <CircularProgress
                        size={type === SIZE_LARGE ? 40 : 20}
                        color="secondary"
                    />
                </Grid>
            </Grid>
        ) : (
            <FormControl>
                <Select
                    input={<Input />}
                    IconComponent={ExpandMore}
                    classes={{
                        root: classNames([
                            classes.root,
                            classes[`${type}Root`],
                            error ? classes.error : null,
                        ]),
                        icon: classNames([
                            classes.icon,
                            type === SIZE_COMPACT ? classes.compactIcon : null,
                            props.disabled ? classes.disabledIcon : null,
                        ]),
                    }}
                    SelectDisplayProps={selectDisplayProps}
                    disableUnderline
                    value={value}
                    className={classes.select}
                    {...props}
                    error={!!error}
                >
                    {options &&
                        options.map((option) => (
                            <MenuItem
                                className={classNames([
                                    type === SIZE_COMPACT
                                        ? classes.compactMenuItem
                                        : null,
                                ])}
                                key={option.value || option}
                                value={
                                    has('value', option) ? option.value : option
                                }
                            >
                                {option.label || option}
                                {renderMenuItemDecorators &&
                                    renderMenuItemDecorators(option)}
                            </MenuItem>
                        ))}
                </Select>
                {error ? (
                    <FormHelperText error className={classes.errorText}>
                        {error}
                    </FormHelperText>
                ) : null}
            </FormControl>
        );
    }
}

AdminSelect.propTypes = {
    // From withStyles we expect to get classes
    classes: PropTypes.object.isRequired,

    // The type of dropdown to render.
    type: PropTypes.oneOf(SIZES),

    error: PropTypes.string,

    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.bool,
    ]),

    // The options that are selectable in the dropdown component.
    options: PropTypes.arrayOf(
        PropTypes.oneOfType([
            PropTypes.node,
            PropTypes.shape({
                value: PropTypes.oneOfType([
                    PropTypes.string,
                    PropTypes.number,
                    PropTypes.bool,
                ]),
                label: PropTypes.node,
            }),
        ]),
    ),

    // Whether this select is in a loading state, if true a circular progress will be shown.
    loading: PropTypes.bool,
    formControlProps: PropTypes.object,
    renderMenuItemDecorators: PropTypes.func,
};

AdminSelect.defaultProps = {
    // If no type is specified, default to large.
    type: SIZE_LARGE,

    loading: false,

    error: null,

    value: null,

    options: null,

    formControlProps: {},

    renderMenuItemDecorators: null,
};

export default withStyles(styles)(AdminSelect);
